import clientData from './client-data'

/**
 * Navigates to cartsummary via a full page load when appClips eligibility is met,
 * so the server can inject the apple-itunes-app meta tag into the HTML response.
 * Returns true if a full page load was triggered, false otherwise.
 */
export const navigateToCartSummary = (search = '') => {
  if (clientData.experimentation?.appClipsEligibility) {
    const basePath = window.location.pathname.substring(
      0,
      window.location.pathname.indexOf(clientData.requestURI) + clientData.requestURI.length,
    )
    window.location.href = `${basePath}/cartsummary${search}`
    return true
  }
  return false
}
